module.exports = __webpack_public_path__ + "static/media/logo-internal.ddb57a5b.png";